import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditRegistration } from "../../controllers/submissions/submissionController";
import { fetchIpAddress } from "../../controllers/API";
import { list as allprogramList } from "../../controllers/cms/admissionPrograms";
import LoadingEffect from "../../components/Loading/LoadingEffect";
import { beforeUploadPDF } from "../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [isLoading, setIsLoading] = useState(false);
  const [learnSource, setLearnSource] = useState(["Facebook", "Instagram", "Google Search", "Parent Reference", "LinkedIn", "Twitter", "Website", "Other"]);

  const [previous_application_details, setPreviousApplications] = useState([
    { child_name: "", program_class: "", applied_year: "" },
    { child_name: "", program_class: "", applied_year: "" },
    { child_name: "", program_class: "", applied_year: "" },
  ]);

  const [rrProgramsList, setrrProgramsList] = useState([
    "U&Me (with Parent) - 1 Yr",
    "U&Me Chutties (without Parent) - 1 Yr",
    "Toddler – 2 Yrs",
    "Tireless Tadpoles – 3 Yrs",
    "Flighty Frogs – 4 Yrs",
    "Bright Bunnies – 5 Yrs",
    "Cool Cats – 6 Yrs",
    "Leaping Lions – 7 Yrs"
  ]);
  const [opProgramsList, setOpProgramsList] = useState([
    "Toddler – 2 Yrs",
    "Tireless Tadpoles – 3 Yrs",
    "Flighty Frogs – 4 Yrs",
    "Bright Bunnies – 5 Yrs",
    "Cool Cats – 6 Yrs",
    "Leaping Lions – 7 Yrs",
    "Dynamic Dolphins – 8 Yrs",
    "Galloping Gazelles – 9 Yrs",
    "Soaring Seagulls – 10 Yrs",
    "6th Grade - 11 Yrs",
    "7th Grade - 12 Yrs",
    "8th Grade - 13 Yrs",
    "9th Grade - 14 Yrs",
    "10th Grade - 15 Yrs",
    "11th Grade - 16 Yrs"
  ]);
  
  // const [programsList, setProgramsList] = useState(ADDEDITDATA?._id  ? ADDEDITDATA?.admission_campus === 'OP-Campus' ? opProgramsList || ADDEDITDATA?.admission_campus === 'RR-Campus' ? rrProgramsList  : [] );
  const [programsList, setProgramsList] = useState(() => {
    if (!ADDEDITDATA?._id) return [];
  
    return ADDEDITDATA.admission_campus === 'OP-Campus'
      ? opProgramsList
      : ADDEDITDATA.admission_campus === 'RR-Campus'
      ? rrProgramsList
      : [];
  });
  
  

  const handlePrevApplicationsChange = (index, field, value) => {
    const updatedApplications = [...previous_application_details];
    updatedApplications[index][field] = value;
    setPreviousApplications(updatedApplications);
    // console.log('previous_application_details',previous_application_details);

    setAddEditSata((prevData) => ({
      ...prevData,
      previous_application_details: updatedApplications,
    }));
  };


    /*********************************************************
     *  This function is used for get all academics list
     *********************************************************/
    // const getProgramsList = async () => {
    //   try {
    //     const programsWhere = {
    //       type: "",
    //       condition: {
    //         status: "A"
    //       }
    //     };
    //     const myPrograms = await allprogramList(programsWhere);
    //     // console.log('myPrograms', myPrograms);
    //     if (myPrograms.result && myPrograms?.result.length > 0) {
    //       setProgramsList(myPrograms.result);
    //     } else {
    //       setProgramsList([]);
    //     }
    //   } catch (error) {
    //     console.log('no pages found');
    //     setProgramsList([]);
    //   }
    // };



  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
    if(e.target.name === 'admission_campus' && e.target.value === 'OP-Campus'){
      setProgramsList(opProgramsList || []);
    } else if (e.target.name === 'admission_campus' && e.target.value === 'RR-Campus'){
      setProgramsList(rrProgramsList || []);
    } else if(e.target.name === 'admission_campus' && e.target.value === '') {
      setProgramsList([]);
    }
  };

  const [learnSourceAddEditData, setLearnSourceAddEditData] = useState([]);
  const handleLearnSourceChange = (value) => {
    setLearnSourceAddEditData(value);
    setError((preError) => ({
      ...preError,
      learn_source: "",
    }));
  };

  const learnSourceOptions = learnSource.map((page) => ({
    value: page,
    label: page,
  }));

  const [firstFile, setFirstFile] = useState([]);
  const [secondFile, setSecondFile] = useState([]);

  const handleFile1Change = (e) => {
    const fileFirstList = e.fileList.slice(-1); // Keep only the last image
    setFirstFile(fileFirstList);
    if (fileFirstList.length === 0) {
      setError(prev => ({ ...prev, file: "First Questionnaire is required." }));
    } else {
      setError(prev => ({ ...prev, file: "" }));
    }
  };

  const handleFile2Change = (e) => {
    const fileSecondList = e.fileList.slice(-1); // Keep only the last image
    setSecondFile(fileSecondList);
    if (fileSecondList.length === 0) {
      setError(prev => ({ ...prev, file: "Second Questionnaire is required." }));
    } else {
      setError(prev => ({ ...prev, file: "" }));
    }
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        gaurdian_email,
        // gaurdian_relationship,  //deprec
        first_name,
        last_name,
        gender,
        dob,
        nationality,
        passport_number,
        place_of_issue,
        passport_exp_date,
        other_passports,
        visa_type,
        visa_issue_date,
        visa_place_of_issue,
        visa_exp_date,
        passport_type,
        previous_school_name,
        current_grade,
        reason_of_leaving,
        home_address,
        phone,
        pin_code,
        state,
        city,
        previously_applied,
        previous_application_details,
        admission_granted,
        admission_taken,
        reason_not_taken,
        sibling_applied_to_kc,
        // sibling_residence_phone, //deprec
        // sibling_pin_code,   //deprec
        // sibling_state,   //deprec
        // sibling_city,    //deprec
        sibling_name,   //new
        sibling_grade,   //new
        is_applying_for_more,   //new 
        father_name,
        Father_occupation,
        Father_work_address,
        father_company_name,   //new
        father_city,
        father_pin_code,
        father_state,
        father_country,
        father_country_code,
        father_phone,
        father_email,
        mother_name,
        mother_occupation,
        mother_work_address,
        mother_company_name,  //new
        mother_pin_code,
        mother_city,
        mother_state,
        mother_country,
        mother_country_code,
        mother_phone,
        mother_email,
        emergency_contacts1,
        emergency_contacts2,
        applied_program,
        admission_campus,   //new
        admission_year,   //new
        second_language_choice,
        // learn_source

      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("gaurdian_email", gaurdian_email ? gaurdian_email:"");
      // form.append("gaurdian_relationship", gaurdian_relationship ? gaurdian_relationship:"");
      form.append("first_name", first_name ? first_name:"");
      form.append("last_name", last_name ? last_name:"");
      form.append("gender", gender ? gender:"");
      form.append("dob", dob ? dob:"");
      form.append("nationality", nationality ? nationality:"");
      form.append("passport_number", passport_number ? passport_number:"");
      form.append("place_of_issue", place_of_issue ? place_of_issue:"");
      form.append("passport_exp_date", passport_exp_date ? passport_exp_date:"");
      form.append("other_passports", other_passports ? other_passports:"");
      form.append("visa_type", visa_type ? visa_type:"");
      form.append("visa_issue_date", visa_issue_date ? visa_issue_date:"");
      form.append("visa_place_of_issue", visa_place_of_issue ? visa_place_of_issue:"");
      form.append("visa_exp_date", visa_exp_date ? visa_exp_date:"");
      form.append("passport_type", passport_type ? passport_type:"");
      form.append("previous_school_name", previous_school_name ? previous_school_name:"");
      form.append("current_grade", current_grade ? current_grade:"");
      form.append("reason_of_leaving", reason_of_leaving ? reason_of_leaving:"");
      form.append("home_address", home_address ? home_address:"");
      form.append("phone", phone ? phone:"");
      form.append("pin_code", pin_code ? pin_code:"");
      form.append("state", state ? state:"");
      form.append("city", city ? city:"");
      form.append("previously_applied", previously_applied ? previously_applied:"");
      form.append("previous_application_details",JSON.stringify(previous_application_details));
      form.append("admission_granted", admission_granted ? admission_granted:"");
      form.append("admission_taken", admission_taken ? admission_taken:"");
      form.append("reason_not_taken", reason_not_taken?reason_not_taken:"");
      form.append("sibling_applied_to_kc", sibling_applied_to_kc ? sibling_applied_to_kc:"");
      // form.append("sibling_residence_phone", sibling_residence_phone ? sibling_residence_phone:"");
      // form.append("sibling_pin_code", sibling_pin_code ? sibling_pin_code:"");
      // form.append("sibling_state", sibling_state ? sibling_state:"");
      // form.append("sibling_city", sibling_city ? sibling_city:""); 
      form.append("sibling_name", sibling_name ? sibling_name:""); 
      form.append("sibling_grade", sibling_grade ? sibling_grade:""); 
      form.append("is_applying_for_more", is_applying_for_more ? is_applying_for_more:"");
      form.append("father_name", father_name ? father_name:"");
      form.append("Father_occupation", Father_occupation ? Father_occupation:"");
      form.append("Father_work_address", Father_work_address ? Father_work_address:"");
      form.append("father_company_name", father_company_name ? father_company_name:"");   // new
      form.append("father_city", father_city ? father_city:"");
      form.append("father_pin_code", father_pin_code ? father_pin_code:"");
      form.append("father_state", father_state ? father_state: "");
      form.append("father_country", father_country ? father_country: "");
      form.append("father_country_code", father_country_code ? father_country_code: "");
      form.append("father_phone", father_phone ? father_phone: "");
      form.append("father_email", father_email ? father_email: "");
      form.append("mother_name", mother_name ? mother_name: "");
      form.append("mother_occupation", mother_occupation ? mother_occupation: "");
      form.append("mother_work_address", mother_work_address ? mother_work_address: "");
      form.append("mother_company_name", mother_company_name ? mother_company_name: "");  // new
      form.append("mother_pin_code", mother_pin_code ? mother_pin_code: "");
      form.append("mother_city", mother_city ? mother_city : "");
      form.append("mother_state", mother_state ? mother_state : "");
      form.append("mother_country", mother_country ? mother_country : "");
      form.append("mother_country_code", mother_country_code ? mother_country_code : "");
      form.append("mother_phone", mother_phone ? mother_phone : "");
      form.append("mother_email", mother_email ? mother_email : "");
      form.append("emergency_contacts1", emergency_contacts1 ? emergency_contacts1 : "");
      form.append("emergency_contacts2", emergency_contacts2 ? emergency_contacts2 : "");
      form.append("applied_program", applied_program ? applied_program : "");
      form.append("admission_campus", admission_campus ? admission_campus : "");  // new
      form.append("admission_year", admission_year ? admission_year : "");  // new
      form.append("second_language_choice", second_language_choice);
      form.append("learn_source", JSON.stringify(learnSourceAddEditData));

      if (firstFile.length > 0) {
        form.append("questionnaire1", firstFile[0]?.originFileObj);
      }
      if (secondFile.length > 0) {
        form.append("questionnaire2", secondFile[0]?.originFileObj);
      }
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: `submission/admission-registeration`,
          postData: form,
        };
        const res = await addEditRegistration(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/registrations");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("first_name").trim() || form.get("first_name").trim() === "undefined" || form.get("first_name").trim() === null) {
      setError((preError) => ({
        ...preError,
        first_name: "First name is required",
      }));
      return false;
    }
    if (!form.get("gender") || form.get("gender") === "undefined" || form.get("gender") === null) {
      setError((preError) => ({
        ...preError,
        gender: "Gender is required",
      }));
      return false;
    }
    if (!form.get("dob") || form.get("dob") === "undefined" || form.get("dob") === null) {
      setError((preError) => ({
        ...preError,
        dob: "D.O.B is required",
      }));
      return false;
    }
    if (!form.get("nationality").trim() || form.get("nationality").trim() === "undefined" || form.get("nationality").trim() === null) {
      setError((preError) => ({
        ...preError,
        nationality: "Nationality is required",
      }));
      return false;
    }
    if (!form.get("gaurdian_email").trim() || form.get("gaurdian_email").trim() === "undefined" || form.get("gaurdian_email").trim() === null) {
      setError((preError) => ({
        ...preError,
        gaurdian_email: "Gaurdian email is required",
      }));
      return false;
    }
    // if (!form.get("gaurdian_relationship").trim() || form.get("gaurdian_relationship").trim() === "undefined" || form.get("gaurdian_relationship").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     gaurdian_relationship: "Gaurdian relationship is required",
    //   }));
    //   return false;
    // }
    if (!form.get("home_address").trim() || form.get("home_address").trim() === "undefined" || form.get("home_address").trim() === null) {
      setError((preError) => ({
        ...preError,
        home_address: "Home address is required",
      }));
      return false;
    }
    if (!form.get("phone").trim() || form.get("phone").trim() === "undefined" || form.get("phone").trim() === null) {
      setError((preError) => ({
        ...preError,
        phone: "Phone is required",
      }));
      return false;
    }
    if (!form.get("pin_code").trim() || form.get("pin_code").trim() === "undefined" || form.get("pin_code").trim() === null) {
      setError((preError) => ({
        ...preError,
        pin_code: "Pincode is required",
      }));
      return false;
    }
    if (!form.get("state").trim() || form.get("state").trim() === "undefined" || form.get("state").trim() === null) {
      setError((preError) => ({
        ...preError,
        state: "State is required",
      }));
      return false;
    }
    if (!form.get("city").trim() || form.get("city").trim() === "undefined" || form.get("city").trim() === null) {
      setError((preError) => ({
        ...preError,
        city: "City is required",
      }));
      return false;
    }
    if (!form.get("father_name").trim() || form.get("father_name").trim() === "undefined" || form.get("father_name").trim() === null) {
      setError((preError) => ({
        ...preError,
        father_name: "Father's name is required",
      }));
      return false;
    }
    if (!form.get("Father_occupation").trim() || form.get("Father_occupation").trim() === "undefined" || form.get("Father_occupation").trim() === null) {
      setError((preError) => ({
        ...preError,
        Father_occupation: "Father's occupation is required",
      }));
      return false;
    }
    // if (!form.get("Father_work_address").trim() || form.get("Father_work_address").trim() === "undefined" || form.get("Father_work_address").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     Father_work_address: "Address is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("father_pin_code").trim() || form.get("father_pin_code").trim() === "undefined" || form.get("father_pin_code").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     father_pin_code: "Pincode is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("father_country").trim() || form.get("father_country").trim() === "undefined" || form.get("father_country").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     father_country: "Country is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("father_state").trim() || form.get("father_state").trim() === "undefined" || form.get("father_state").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     father_state: "State is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("father_city").trim() || form.get("father_city").trim() === "undefined" || form.get("father_city").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     father_city: "City is required",
    //   }));
    //   return false;
    // }
    if (!form.get("father_phone").trim() || form.get("father_phone").trim() === "undefined" || form.get("father_phone").trim() === null) {
      setError((preError) => ({
        ...preError,
        father_phone: "Phone is required",
      }));
      return false;
    }
    // if (!form.get("father_email").trim() || form.get("father_email").trim() === "undefined" || form.get("father_email").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     father_email: "Email is required",
    //   }));
    //   return false;
    // }
    if (!form.get("mother_name").trim() || form.get("mother_name").trim() === "undefined" || form.get("mother_name").trim() === null) {
      setError((preError) => ({
        ...preError,
        mother_name: "Mother's name is required",
      }));
      return false;
    }
    if (!form.get("mother_occupation").trim() || form.get("mother_occupation").trim() === "undefined" || form.get("mother_occupation").trim() === null) {
      setError((preError) => ({
        ...preError,
        mother_occupation: "Mother's occupation is required",
      }));
      return false;
    }
    // if (!form.get("mother_work_address").trim() || form.get("mother_work_address").trim() === "undefined" || form.get("mother_work_address").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     mother_work_address: "Address is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("mother_pin_code").trim() || form.get("mother_pin_code").trim() === "undefined" || form.get("mother_pin_code").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     mother_pin_code: "Pincode is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("mother_country").trim() || form.get("mother_country").trim() === "undefined" || form.get("mother_country").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     mother_country: "Country is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("mother_state").trim() || form.get("mother_state").trim() === "undefined" || form.get("mother_state").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     mother_state: "State is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("mother_city").trim() || form.get("mother_city").trim() === "undefined" || form.get("mother_city").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     mother_city: "City is required",
    //   }));
    //   return false;
    // }
    if (!form.get("mother_phone").trim() || form.get("mother_phone").trim() === "undefined" || form.get("mother_phone").trim() === null) {
      setError((preError) => ({
        ...preError,
        mother_phone: "Phone is required",
      }));
      return false;
    }
    // if (!form.get("mother_email").trim() || form.get("mother_email").trim() === "undefined" || form.get("mother_email").trim() === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     mother_email: "Email is required",
    //   }));
    //   return false;
    // }
    if (!form.get("applied_program") || form.get("applied_program") === "undefined" || form.get("applied_program") === null) {
      setError((preError) => ({
        ...preError,
        applied_program: "Please select a program",
      }));
      return false;
    }
    if (!form.get("admission_campus") || form.get("admission_campus") === "undefined" || form.get("admission_campus") === null) {
      setError((preError) => ({
        ...preError,
        admission_campus: "Please select campus",
      }));
      return false;
    }
    if (!form.get("admission_year") || form.get("admission_year") === "undefined" || form.get("admission_year") === null) {
      setError((preError) => ({
        ...preError,
        admission_year: "Please select year",
      }));
      return false;
    }
    return true;
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    if(ADDEDITDATA?._id){
      setLearnSourceAddEditData(ADDEDITDATA?.learn_source);
      setPreviousApplications(ADDEDITDATA?.previous_application_details);
    }
    // getProgramsList();
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Registration`;
  }, [ADDEDITDATA]);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Registration
            </h5>
          </div>
          <Link to="/registrations">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <h5>Basic Details</h5>
                  <hr></hr>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="first_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>First name :{" "}
                    </label>
                    <input
                      title="Enter first name"
                      placeholder="Enter first name"
                      type="text"
                      name="first_name"
                      className="form-control store_input_field"
                      id="first_name"
                      value={ADDEDITDATA?.first_name}
                      onChange={handleChange}
                    />
                    {error.first_name ? (
                      <p style={{ color: "red" }}>
                        {error.first_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="last_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Last name :{" "}
                    </label>
                    <input
                      title="Enter last name"
                      placeholder="Enter last name"
                      type="text"
                      name="last_name"
                      className="form-control store_input_field"
                      id="last_name"
                      value={ADDEDITDATA?.last_name}
                      onChange={handleChange}
                    />
                    {error.last_name ? (
                      <p style={{ color: "red" }}>
                        {error.last_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                    <label for="gender" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Gender</label>
                    <select className="form-control categories_select_tg_enter_product" name='gender' id='gender' onChange={handleChange}>
                      <option value='' selected={ADDEDITDATA?.gender === 'Select gender' ? true : false}>Select gender</option>
                      <option value='Male' selected={ADDEDITDATA?.gender === 'Male' ? true : false}>Male</option>
                      <option value='Female' selected={ADDEDITDATA?.gender === 'Female' ? true : false}>Female</option>
                      <option value='Prefer not to choose' selected={ADDEDITDATA?.gender === 'Prefer not to choose' ? true : false}>Prefer not to choose</option>
                    </select>
                    {error.gender ? (<p style={{ color: "red" }}> {error.gender} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="dob"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>D.O.B :{" "}
                    </label>
                    <input
                      title="Enter date of birth"
                      placeholder="Enter date of birth"
                      type="date"
                      name="dob"
                      className="form-control store_input_field"
                      id="dob"
                      value={ADDEDITDATA?.dob}
                      onChange={handleChange}
                    />
                    {error.dob ? (
                      <p style={{ color: "red" }}>
                        {error.dob}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="nationality"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Nationality :{" "}
                    </label>
                    <input
                      title="Enter nationality"
                      placeholder="Enter nationality"
                      type="text"
                      name="nationality"
                      className="form-control store_input_field"
                      id="nationality"
                      value={ADDEDITDATA?.nationality}
                      onChange={handleChange}
                    />
                    {error.nationality ? (
                      <p style={{ color: "red" }}>
                        {error.nationality}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="gaurdian_email"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Parent/Guardian Email :{" "}
                    </label>
                    <input
                      title="Parent/Guardian Email"
                      placeholder="Parent/Guardian Email"
                      type="text"
                      name="gaurdian_email"
                      className="form-control store_input_field"
                      id="gaurdian_email"
                      value={ADDEDITDATA?.gaurdian_email}
                      onChange={handleChange}
                    />
                    {error.gaurdian_email ? (
                      <p style={{ color: "red" }}>
                        {error.gaurdian_email}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="gaurdian_relationship"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Gaurdian relationship :{" "}
                    </label>
                    <input
                      title="Enter relationship"
                      placeholder="Enter relationship"
                      type="text"
                      name="gaurdian_relationship"
                      className="form-control store_input_field"
                      id="gaurdian_relationship"
                      value={ADDEDITDATA?.gaurdian_relationship}
                      onChange={handleChange}
                    />
                    {error.gaurdian_relationship ? (
                      <p style={{ color: "red" }}>
                        {error.gaurdian_relationship}
                      </p>
                    ) : (
                      ""
                    )}
                  </div> */}
                </div>
                <div className="row mt-3">
                <h5>Programs for which admission is sought</h5>
                  <hr></hr>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <label for="admission_campus" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Select campus</label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='admission_campus' id='admission_campus' onChange={handleChange}>
                      <option value='' selected={ADDEDITDATA?.admission_campus === 'Select Program' ? true : false}>Select campus</option>
                      <option value='OP-Campus' selected={ADDEDITDATA?.admission_campus === 'OP-Campus' ? true : false}>OP Campus - Navalur (2 - 16 Yrs)</option>
                      <option value='RR-Campus' selected={ADDEDITDATA?.admission_campus === 'RR-Campus' ? true : false}>Kotturpuram (KP) Campus (1 - 7 Yrs)</option>
                    </select>
                    {error.admission_campus ? (<p style={{ color: "red" }}> {error.admission_campus} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <label for="admission_year" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Select admission year</label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='admission_year' id='admission_year' onChange={handleChange}>
                      <option value='' selected={ADDEDITDATA?.admission_year === '' ? true : false}>Select admission year</option>
                      <option value='2024-2025' selected={ADDEDITDATA?.admission_year === '2024-2025' ? true : false}>2024-2025</option>
                      <option value='2025-2026' selected={ADDEDITDATA?.admission_year === '2025-2026' ? true : false}>2025-2026</option>
                    </select>
                    {error.admission_year ? (<p style={{ color: "red" }}> {error.admission_year} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <label for="applied_program" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Select Program</label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='applied_program' id='applied_program' onChange={handleChange}>
                      <option value=''>Select Program</option>
                      {programsList && programsList.map(programs => (
                        <option
                          key={programs}
                          value={programs}
                          selected={ADDEDITDATA?.applied_program === programs ? true : false}
                        >
                          {programs}
                        </option>
                      ))}
                    </select>
                    {error.applied_program ? (<p style={{ color: "red" }}> {error.applied_program} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                    <label for="second_language_choice" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Select second language choice</label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='second_language_choice' id='second_language_choice' onChange={handleChange}>
                      <option value='' selected={ADDEDITDATA?.second_language_choice === 'Select Program' ? true : false}>Select second language choice</option>
                      <option value='French' selected={ADDEDITDATA?.second_language_choice === 'French' ? true : false}>French</option>
                      <option value='Hindi' selected={ADDEDITDATA?.second_language_choice === 'Hindi' ? true : false}>Hindi</option>
                      <option value='Spanish' selected={ADDEDITDATA?.second_language_choice === 'Spanish' ? true : false}>Spanish</option>
                      <option value='French' selected={ADDEDITDATA?.second_language_choice === 'French' ? true : false}>French (to be selected only for Grade 6 upwards)</option>
                    </select>
                    {error.second_language_choice ? (<p style={{ color: "red" }}> {error.second_language_choice} </p>) : ("")}
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Passport Details</h5>
                  <hr></hr>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="passport_number"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Child Passport No. :{" "}
                    </label>
                    <input
                      title="Enter child passport no."
                      placeholder="Enter child passport no."
                      type="text"
                      name="passport_number"
                      className="form-control store_input_field"
                      id="passport_number"
                      value={ADDEDITDATA?.passport_number}
                      onChange={handleChange}
                    />
                    {error.passport_number ? (
                      <p style={{ color: "red" }}>
                        {error.passport_number}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="place_of_issue"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Passport issue place :{" "}
                    </label>
                    <input
                      title="Enter Passport issue place"
                      placeholder="Enter Passport issue place"
                      type="text"
                      name="place_of_issue"
                      className="form-control store_input_field"
                      id="place_of_issue"
                      value={ADDEDITDATA?.place_of_issue}
                      onChange={handleChange}
                    />
                    {error.place_of_issue ? (
                      <p style={{ color: "red" }}>
                        {error.place_of_issue}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="passport_exp_date"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Passport expiry date :{" "}
                    </label>
                    <input
                      title="Enter Passport expiry date"
                      placeholder="Enter Passport expiry date"
                      type="date"
                      name="passport_exp_date"
                      className="form-control store_input_field"
                      id="passport_exp_date"
                      value={ADDEDITDATA?.passport_exp_date}
                      onChange={handleChange}
                    />
                    {error.passport_exp_date ? (
                      <p style={{ color: "red" }}>
                        {error.passport_exp_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="other_passports"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Other Passports :{" "}
                    </label>
                    <input
                      title="Enter Other Passports"
                      placeholder="Enter Other Passports"
                      type="text"
                      name="other_passports"
                      className="form-control store_input_field"
                      id="other_passports"
                      value={ADDEDITDATA?.other_passports}
                      onChange={handleChange}
                    />
                    {error.other_passports ? (
                      <p style={{ color: "red" }}>
                        {error.other_passports}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="passport_type"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Type of passport :{" "}
                    </label>
                    <input
                      title="Enter Type of passport"
                      placeholder="Enter Type of passport"
                      type="text"
                      name="passport_type"
                      className="form-control store_input_field"
                      id="passport_type"
                      value={ADDEDITDATA?.passport_type}
                      onChange={handleChange}
                    />
                    {error.passport_type ? (
                      <p style={{ color: "red" }}>
                        {error.passport_type}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="visa_issue_date"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Visa issue date :{" "}
                    </label>
                    <input
                      title="Enter Visa issue date"
                      placeholder="Enter Visa issue date"
                      type="date"
                      name="visa_issue_date"
                      className="form-control store_input_field"
                      id="visa_issue_date"
                      value={ADDEDITDATA?.visa_issue_date}
                      onChange={handleChange}
                    />
                    {error.visa_issue_date ? (
                      <p style={{ color: "red" }}>
                        {error.visa_issue_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="visa_place_of_issue"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Visa issue place :{" "}
                    </label>
                    <input
                      title="Enter Visa issue place"
                      placeholder="Enter Visa issue place"
                      type="text"
                      name="visa_place_of_issue"
                      className="form-control store_input_field"
                      id="visa_place_of_issue"
                      value={ADDEDITDATA?.visa_place_of_issue}
                      onChange={handleChange}
                    />
                    {error.visa_place_of_issue ? (
                      <p style={{ color: "red" }}>
                        {error.visa_place_of_issue}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="visa_exp_date"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Visa expiry date :{" "}
                    </label>
                    <input
                      title="Enter Visa expiry date"
                      placeholder="Enter Visa expiry date"
                      type="date"
                      name="visa_exp_date"
                      className="form-control store_input_field"
                      id="visa_exp_date"
                      value={ADDEDITDATA?.visa_exp_date}
                      onChange={handleChange}
                    />
                    {error.visa_exp_date ? (
                      <p style={{ color: "red" }}>
                        {error.visa_exp_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="visa_type"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Type of Visa :{" "}
                    </label>
                    <input
                      title="Enter Type of Visa"
                      placeholder="Enter Type of Visa"
                      type="text"
                      name="visa_type"
                      className="form-control store_input_field"
                      id="visa_type"
                      value={ADDEDITDATA?.visa_type}
                      onChange={handleChange}
                    />
                    {error.visa_type ? (
                      <p style={{ color: "red" }}>
                        {error.visa_type}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Home details</h5>
                  <hr></hr>
                  <div className="form-group col-lg-8 col-md-8 col-sm-8 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="home_address"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Address :{" "}
                    </label>
                    <input
                      title="Enter home address"
                      placeholder="Enter home address"
                      type="text"
                      name="home_address"
                      className="form-control store_input_field"
                      id="home_address"
                      value={ADDEDITDATA?.home_address}
                      onChange={handleChange}
                    />
                    {error.home_address ? (
                      <p style={{ color: "red" }}>
                        {error.home_address}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="pin_code"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Pincode :{" "}
                    </label>
                    <input
                      title="Enter pincode"
                      placeholder="Enter pincode"
                      type="text"
                      name="pin_code"
                      className="form-control store_input_field"
                      id="pin_code"
                      value={ADDEDITDATA?.pin_code}
                      onChange={handleChange}
                    />
                    {error.pin_code ? (
                      <p style={{ color: "red" }}>
                        {error.pin_code}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="phone"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Phone :{" "}
                    </label>
                    <input
                      title="Enter phone"
                      placeholder="Enter phone"
                      type="text"
                      name="phone"
                      className="form-control store_input_field"
                      id="phone"
                      value={ADDEDITDATA?.phone}
                      onChange={handleChange}
                    />
                    {error.phone ? (
                      <p style={{ color: "red" }}>
                        {error.phone}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="state"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>State :{" "}
                    </label>
                    <input
                      title="Enter state"
                      placeholder="Enter state"
                      type="text"
                      name="state"
                      className="form-control store_input_field"
                      id="state"
                      value={ADDEDITDATA?.state}
                      onChange={handleChange}
                    />
                    {error.state ? (
                      <p style={{ color: "red" }}>
                        {error.state}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="city"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>City :{" "}
                    </label>
                    <input
                      title="Enter city"
                      placeholder="Enter city"
                      type="text"
                      name="city"
                      className="form-control store_input_field"
                      id="city"
                      value={ADDEDITDATA?.city}
                      onChange={handleChange}
                    />
                    {error.city ? (
                      <p style={{ color: "red" }}>
                        {error.city}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Father/Gaurdian details</h5>
                  <hr></hr>
                  <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Name :{" "}
                    </label>
                    <input
                      title="Enter father's name"
                      placeholder="Enter father's name"
                      type="text"
                      name="father_name"
                      className="form-control store_input_field"
                      id="father_name"
                      value={ADDEDITDATA?.father_name}
                      onChange={handleChange}
                    />
                    {error.father_name ? (
                      <p style={{ color: "red" }}>
                        {error.father_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="Father_occupation"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Occupation :{" "}
                    </label>
                    <input
                      title="Enter father's occupation"
                      placeholder="Enter father's occupation"
                      type="text"
                      name="Father_occupation"
                      className="form-control store_input_field"
                      id="Father_occupation"
                      value={ADDEDITDATA?.Father_occupation}
                      onChange={handleChange}
                    />
                    {error.Father_occupation ? (
                      <p style={{ color: "red" }}>
                        {error.Father_occupation}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_company_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Company name :{" "}
                    </label>
                    <input
                      title="Enter company name"
                      placeholder="Enter company name"
                      type="text"
                      name="father_company_name"
                      className="form-control store_input_field"
                      id="father_company_name"
                      value={ADDEDITDATA?.father_company_name}
                      onChange={handleChange}
                    />
                    {error.father_company_name ? (
                      <p style={{ color: "red" }}>
                        {error.father_company_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-8 col-md-8 col-sm-8 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="Father_work_address"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Work Address :{" "}
                    </label>
                    <input
                      title="Enter work address"
                      placeholder="Enter work address"
                      type="text"
                      name="Father_work_address"
                      className="form-control store_input_field"
                      id="Father_work_address"
                      value={ADDEDITDATA?.Father_work_address}
                      onChange={handleChange}
                    />
                    {error.Father_work_address ? (
                      <p style={{ color: "red" }}>
                        {error.Father_work_address}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_pin_code"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Pincode :{" "}
                    </label>
                    <input
                      title="Enter pincode"
                      placeholder="Enter pincode"
                      type="text"
                      name="father_pin_code"
                      className="form-control store_input_field"
                      id="father_pin_code"
                      value={ADDEDITDATA?.father_pin_code}
                      onChange={handleChange}
                    />
                    {error.father_pin_code ? (
                      <p style={{ color: "red" }}>
                        {error.father_pin_code}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_country"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Country :{" "}
                    </label>
                    <input
                      title="Enter country"
                      placeholder="Enter country"
                      type="text"
                      name="father_country"
                      className="form-control store_input_field"
                      id="father_country"
                      value={ADDEDITDATA?.father_country}
                      onChange={handleChange}
                    />
                    {error.father_country ? (
                      <p style={{ color: "red" }}>
                        {error.father_country}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_state"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    State :{" "}
                    </label>
                    <input
                      title="Enter state"
                      placeholder="Enter state"
                      type="text"
                      name="father_state"
                      className="form-control store_input_field"
                      id="father_state"
                      value={ADDEDITDATA?.father_state}
                      onChange={handleChange}
                    />
                    {error.father_state ? (
                      <p style={{ color: "red" }}>
                        {error.father_state}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_city"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    City :{" "}
                    </label>
                    <input
                      title="Enter city"
                      placeholder="Enter city"
                      type="text"
                      name="father_city"
                      className="form-control store_input_field"
                      id="father_city"
                      value={ADDEDITDATA?.father_city}
                      onChange={handleChange}
                    />
                    {error.father_city ? (
                      <p style={{ color: "red" }}>
                        {error.father_city}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-2 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_country_code"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Country code :{" "}
                    </label>
                    <input
                      title="Enter country code"
                      placeholder="Enter country code"
                      type="text"
                      name="father_country_code"
                      className="form-control store_input_field"
                      id="father_country_code"
                      value={ADDEDITDATA?.father_country_code}
                      onChange={handleChange}
                    />
                    {error.father_country_code ? (
                      <p style={{ color: "red" }}>
                        {error.father_country_code}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-5 col-md-5 col-sm-5 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_phone"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Phone :{" "}
                    </label>
                    <input
                      title="Enter phone"
                      placeholder="Enter phone"
                      type="text"
                      name="father_phone"
                      className="form-control store_input_field"
                      id="father_phone"
                      value={ADDEDITDATA?.father_phone}
                      onChange={handleChange}
                    />
                    {error.father_phone ? (
                      <p style={{ color: "red" }}>
                        {error.father_phone}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-5 col-md-5 col-sm-5 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="father_email"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Email :{" "}
                    </label>
                    <input
                      title="Enter email"
                      placeholder="Enter email"
                      type="text"
                      name="father_email"
                      className="form-control store_input_field"
                      id="father_email"
                      value={ADDEDITDATA?.father_email}
                      onChange={handleChange}
                    />
                    {error.father_email ? (
                      <p style={{ color: "red" }}>
                        {error.father_email}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Mother/Gaurdian details</h5>
                  <hr></hr>
                  <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Name :{" "}
                    </label>
                    <input
                      title="Enter name"
                      placeholder="Enter name"
                      type="text"
                      name="mother_name"
                      className="form-control store_input_field"
                      id="mother_name"
                      value={ADDEDITDATA?.mother_name}
                      onChange={handleChange}
                    />
                    {error.mother_name ? (
                      <p style={{ color: "red" }}>
                        {error.mother_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_occupation"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Occupation :{" "}
                    </label>
                    <input
                      title="Enter occupation"
                      placeholder="Enter occupation"
                      type="text"
                      name="mother_occupation"
                      className="form-control store_input_field"
                      id="mother_occupation"
                      value={ADDEDITDATA?.mother_occupation}
                      onChange={handleChange}
                    />
                    {error.mother_occupation ? (
                      <p style={{ color: "red" }}>
                        {error.mother_occupation}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_company_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Company name :{" "}
                    </label>
                    <input
                      title="Enter company name"
                      placeholder="Enter company name"
                      type="text"
                      name="mother_company_name"
                      className="form-control store_input_field"
                      id="mother_company_name"
                      value={ADDEDITDATA?.mother_company_name}
                      onChange={handleChange}
                    />
                    {error.mother_company_name ? (
                      <p style={{ color: "red" }}>
                        {error.mother_company_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-8 col-md-8 col-sm-8 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_work_address"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Address :{" "}
                    </label>
                    <input
                      title="Enter work address"
                      placeholder="Enter work address"
                      type="text"
                      name="mother_work_address"
                      className="form-control store_input_field"
                      id="mother_work_address"
                      value={ADDEDITDATA?.mother_work_address}
                      onChange={handleChange}
                    />
                    {error.mother_work_address ? (
                      <p style={{ color: "red" }}>
                        {error.mother_work_address}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_pin_code"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Pincode :{" "}
                    </label>
                    <input
                      title="Enter pincode"
                      placeholder="Enter pincode"
                      type="text"
                      name="mother_pin_code"
                      className="form-control store_input_field"
                      id="mother_pin_code"
                      value={ADDEDITDATA?.mother_pin_code}
                      onChange={handleChange}
                    />
                    {error.mother_pin_code ? (
                      <p style={{ color: "red" }}>
                        {error.mother_pin_code}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_country"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Country :{" "}
                    </label>
                    <input
                      title="Enter country"
                      placeholder="Enter country"
                      type="text"
                      name="mother_country"
                      className="form-control store_input_field"
                      id="mother_country"
                      value={ADDEDITDATA?.mother_country}
                      onChange={handleChange}
                    />
                    {error.mother_country ? (
                      <p style={{ color: "red" }}>
                        {error.mother_country}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_state"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    State :{" "}
                    </label>
                    <input
                      title="Enter state"
                      placeholder="Enter state"
                      type="text"
                      name="mother_state"
                      className="form-control store_input_field"
                      id="mother_state"
                      value={ADDEDITDATA?.mother_state}
                      onChange={handleChange}
                    />
                    {error.mother_state ? (
                      <p style={{ color: "red" }}>
                        {error.mother_state}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_city"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    City :{" "}
                    </label>
                    <input
                      title="Enter city"
                      placeholder="Enter city"
                      type="text"
                      name="mother_city"
                      className="form-control store_input_field"
                      id="mother_city"
                      value={ADDEDITDATA?.mother_city}
                      onChange={handleChange}
                    />
                    {error.mother_city ? (
                      <p style={{ color: "red" }}>
                        {error.mother_city}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-2 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_country_code"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Country code :{" "}
                    </label>
                    <input
                      title="Enter country code"
                      placeholder="Enter country code"
                      type="text"
                      name="mother_country_code"
                      className="form-control store_input_field"
                      id="mother_country_code"
                      value={ADDEDITDATA?.mother_country_code}
                      onChange={handleChange}
                    />
                    {error.mother_country_code ? (
                      <p style={{ color: "red" }}>
                        {error.mother_country_code}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-5 col-md-5 col-sm-5 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_phone"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Phone :{" "}
                    </label>
                    <input
                      title="Enter phone"
                      placeholder="Enter phone"
                      type="text"
                      name="mother_phone"
                      className="form-control store_input_field"
                      id="mother_phone"
                      value={ADDEDITDATA?.mother_phone}
                      onChange={handleChange}
                    />
                    {error.mother_phone ? (
                      <p style={{ color: "red" }}>
                        {error.mother_phone}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-5 col-md-5 col-sm-5 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mother_email"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Email :{" "}
                    </label>
                    <input
                      title="Enter email"
                      placeholder="Enter email"
                      type="text"
                      name="mother_email"
                      className="form-control store_input_field"
                      id="mother_email"
                      value={ADDEDITDATA?.mother_email}
                      onChange={handleChange}
                    />
                    {error.mother_email ? (
                      <p style={{ color: "red" }}>
                        {error.mother_email}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Sibling details</h5>
                  <hr></hr>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <label for="sibling_applied_to_kc" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span>Do you have a sibling who is currently studying or has studied at KC? </label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='sibling_applied_to_kc' id='sibling_applied_to_kc' onChange={handleChange}>
                      <option value='No' selected={ADDEDITDATA?.sibling_applied_to_kc === 'No' ? true : false}>No</option>
                      <option value='Yes' selected={ADDEDITDATA?.sibling_applied_to_kc === 'Yes' ? true : false}>Yes</option>
                    </select>
                    {error.sibling_applied_to_kc ? (<p style={{ color: "red" }}> {error.sibling_applied_to_kc} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="sibling_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Sibling's name :{" "}
                    </label>
                    <input
                      title="Enter name"
                      placeholder="Enter name"
                      type="text"
                      name="sibling_name"
                      className="form-control store_input_field"
                      id="sibling_name"
                      value={ADDEDITDATA?.sibling_name}
                      onChange={handleChange}
                    />
                    {error.sibling_name ? (
                      <p style={{ color: "red" }}>
                        {error.sibling_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="sibling_grade"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Sibling's grade :{" "}
                    </label>
                    <input
                      title="Enter grade"
                      placeholder="Enter grade"
                      type="text"
                      name="sibling_grade"
                      className="form-control store_input_field"
                      id="sibling_grade"
                      value={ADDEDITDATA?.sibling_grade}
                      onChange={handleChange}
                    />
                    {error.sibling_grade ? (
                      <p style={{ color: "red" }}>
                        {error.sibling_grade}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <label for="is_applying_for_more" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Are you applying for more than one child ? </label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='is_applying_for_more' id='is_applying_for_more' onChange={handleChange}>
                      <option value='No' selected={ADDEDITDATA?.is_applying_for_more === 'No' ? true : false}>No</option>
                      <option value='Yes' selected={ADDEDITDATA?.is_applying_for_more === 'Yes' ? true : false}>Yes</option>
                    </select>
                    {error.is_applying_for_more ? (<p style={{ color: "red" }}> {error.is_applying_for_more} </p>) : ("")}
                  </div>
                  {/* <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="sibling_pin_code"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Pincode :{" "}
                    </label>
                    <input
                      title="Enter Pincode"
                      placeholder="Enter Pincode"
                      type="text"
                      name="sibling_pin_code"
                      className="form-control store_input_field"
                      id="sibling_pin_code"
                      value={ADDEDITDATA?.sibling_pin_code}
                      onChange={handleChange}
                    />
                    {error.sibling_pin_code ? (
                      <p style={{ color: "red" }}>
                        {error.sibling_pin_code}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="sibling_state"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>State :{" "}
                    </label>
                    <input
                      title="Enter state"
                      placeholder="Enter state"
                      type="text"
                      name="sibling_state"
                      className="form-control store_input_field"
                      id="sibling_state"
                      value={ADDEDITDATA?.sibling_state}
                      onChange={handleChange}
                    />
                    {error.sibling_state ? (
                      <p style={{ color: "red" }}>
                        {error.sibling_state}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="sibling_city"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>City :{" "}
                    </label>
                    <input
                      title="Enter city"
                      placeholder="Enter city"
                      type="text"
                      name="sibling_city"
                      className="form-control store_input_field"
                      id="sibling_city"
                      value={ADDEDITDATA?.sibling_city}
                      onChange={handleChange}
                    />
                    {error.sibling_city ? (
                      <p style={{ color: "red" }}>
                        {error.sibling_city}
                      </p>
                    ) : (
                      ""
                    )}
                  </div> */}
                </div>
                <div className="row mt-3">
                  <h5>Previously attended school details</h5>
                  <hr></hr>
                  <span style={{ color: "red" }}>Enter N/A if none*</span>
                  <div className="form-group col-lg-8 col-md-8 col-sm-8 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="previous_school_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      School name :{" "}
                    </label>
                    <input
                      title="Enter previous school name"
                      placeholder="Enter previous school name"
                      type="text"
                      name="previous_school_name"
                      className="form-control store_input_field"
                      id="previous_school_name"
                      value={ADDEDITDATA?.previous_school_name}
                      onChange={handleChange}
                    />
                    {error.previous_school_name ? (
                      <p style={{ color: "red" }}>
                        {error.previous_school_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="current_grade"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                    Current grade :{" "}
                    </label>
                    <input
                      title="Enter current grade"
                      placeholder="Enter current grade"
                      type="text"
                      name="current_grade"
                      className="form-control store_input_field"
                      id="current_grade"
                      value={ADDEDITDATA?.current_grade}
                      onChange={handleChange}
                    />
                    {error.current_grade ? (
                      <p style={{ color: "red" }}>
                        {error.current_grade}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="reason_of_leaving"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      Reason of leaving :{" "}
                    </label>
                    <input
                      title="Enter reason of leaving"
                      placeholder="Enter reason of leaving"
                      type="text"
                      name="reason_of_leaving"
                      className="form-control store_input_field"
                      id="reason_of_leaving"
                      value={ADDEDITDATA?.reason_of_leaving}
                      onChange={handleChange}
                    />
                    {error.reason_of_leaving ? (
                      <p style={{ color: "red" }}>
                        {error.reason_of_leaving}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Other details</h5>
                  <hr></hr>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <label for="previously_applied" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Have you applied to KC earlier for your child/children?</label>
                    <select className="form-control categories_select_tg_enter_product" name='previously_applied' id='previously_applied' onChange={handleChange}>
                      <option value='No' selected={ADDEDITDATA?.previously_applied === 'No' ? true : false}>No</option>
                      <option value='Yes' selected={ADDEDITDATA?.previously_applied === 'Yes' ? true : false}>Yes</option>
                    </select>
                    {error.previously_applied ? (<p style={{ color: "red" }}> {error.previously_applied} </p>) : ("")}
                  </div>
                  {previous_application_details.map((app, index) => (
                    <>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="child_name"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Child name :{" "}
                    </label>
                    <input
                      title="Enter child name"
                      placeholder="Enter child name"
                      type="text"
                      name="child_name"
                      className="form-control store_input_field"
                      id="child_name"
                      // value={ADDEDITDATA?.child_name}
                      value={app.child_name}
                      // onChange={handleChange}
                      onChange={(e) =>
                        handlePrevApplicationsChange(index, "child_name", e.target.value)
                      }
                    />
                    {error.child_name ? (
                      <p style={{ color: "red" }}>
                        {error.child_name}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="program_class"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Prgram/Class :{" "}
                    </label>
                    <input
                      title="Enter program/class"
                      placeholder="Enter program/class"
                      type="text"
                      name="program_class"
                      className="form-control store_input_field"
                      id="program_class"
                      // value={ADDEDITDATA?.program_class}
                      // onChange={handleChange}
                      value={app.program_class}
                      onChange={(e) =>
                        handlePrevApplicationsChange(index, "program_class", e.target.value)
                      }
                    />
                    {error.program_class ? (
                      <p style={{ color: "red" }}>
                        {error.program_class}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="applied_year"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Applied Year :{" "}
                    </label>
                    <input
                      title="Enter Applied Year"
                      placeholder="Enter Applied Year"
                      type="text"
                      name="applied_year"
                      className="form-control store_input_field"
                      id="applied_year"
                      // value={ADDEDITDATA?.applied_year}
                      // onChange={handleChange}
                      value={app.applied_year}
                      onChange={(e) =>
                        handlePrevApplicationsChange(index, "applied_year", e.target.value)
                      }
                    />
                    {error.applied_year ? (
                      <p style={{ color: "red" }}>
                        {error.applied_year}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  </>
                  ))}
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <label for="admission_granted" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span>Were you granted admission?</label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='admission_granted' id='admission_granted' onChange={handleChange}>
                      <option value='No' selected={ADDEDITDATA?.admission_granted === 'No' ? true : false}>No</option>
                      <option value='Yes' selected={ADDEDITDATA?.admission_granted === 'Yes' ? true : false}>Yes</option>
                      <option value='Does not apply' selected={ADDEDITDATA?.admission_granted === 'Does not apply' ? true : false}>Does not apply</option>
                    </select>
                    {error.admission_granted ? (<p style={{ color: "red" }}> {error.admission_granted} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <label for="admission_taken" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span>If yes, did you take up the admission in KC?</label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='admission_taken' id='admission_taken' onChange={handleChange}>
                      <option value='No' selected={ADDEDITDATA?.admission_taken === 'No' ? true : false}>No</option>
                      <option value='Yes' selected={ADDEDITDATA?.admission_taken === 'Yes' ? true : false}>Yes</option>
                      <option value='Does not apply' selected={ADDEDITDATA?.admission_taken === 'Does not apply' ? true : false}>Does not apply</option>
                    </select>
                    {error.admission_taken ? (<p style={{ color: "red" }}> {error.admission_taken} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="reason_not_taken"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>If not, please mention why. :
                    </label>
                    <textarea
                      title="Enter reason"
                      placeholder="Enter reason"
                      type="text"
                      name="reason_not_taken"
                      className="form-control store_input_field"
                      id="reason_not_taken"
                      value={ADDEDITDATA?.reason_not_taken}
                      onChange={handleChange}
                    />
                    {error.reason_not_taken ? (
                      <p style={{ color: "red" }}>{error.reason_not_taken}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                    <label htmlFor="learn_source" className="all_lebel_margin_top_main_div"><span style={{ color: "red" }}>*</span>How did you learn about KC High? : </label>
                    <Select
                      mode="multiple"
                      placeholder="Select source"
                      variant="learn_source"
                      name="learn_source"
                      className="form-control store_input_field mt-2"
                      style={{ flex: 1 }}
                      value={learnSourceAddEditData}
                      onChange={handleLearnSourceChange}
                      options={learnSourceOptions}
                    />
                    {error.learn_source ? (
                      <p style={{ color: "red" }}>{error.learn_source}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <h5>Emergency contacts</h5>
                  <hr></hr>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="emergency_contacts1"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Contact 1 :{" "}
                    </label>
                    <input
                      title="Enter contact 1"
                      placeholder="Enter contact 1"
                      type="text"
                      name="emergency_contacts1"
                      className="form-control store_input_field"
                      id="emergency_contacts1"
                      value={ADDEDITDATA?.emergency_contacts1}
                      onChange={handleChange}
                    />
                    {error.emergency_contacts1 ? (
                      <p style={{ color: "red" }}>
                        {error.emergency_contacts1}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="emergency_contacts2"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Contact 2 :{" "}
                    </label>
                    <input
                      title="Enter contact 2"
                      placeholder="Enter contact 2"
                      type="text"
                      name="emergency_contacts2"
                      className="form-control store_input_field"
                      id="emergency_contacts2"
                      value={ADDEDITDATA?.emergency_contacts2}
                      onChange={handleChange}
                    />
                    {error.emergency_contacts2 ? (
                      <p style={{ color: "red" }}>
                        {error.emergency_contacts2}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="all_section_for_label_main_class all_lebel_margin_top_main_div" >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    First Questionnaire
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    // listType="picture"
                    onChange={handleFile1Change}
                    beforeUpload={beforeUploadPDF}
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an file format (PDF)
                  </p>
                  {error.file ? (
                    <p style={{ color: "red" }}>{error.file}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-group">
                  <label className="all_section_for_label_main_class all_lebel_margin_top_main_div" >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Second Questionnaire
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    // listType="picture"
                    onChange={handleFile2Change}
                    beforeUpload={beforeUploadPDF}
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an file format (PDF)
                  </p>
                  {error.file ? (
                    <p style={{ color: "red" }}>{error.file}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
